// extracted by mini-css-extract-plugin
module.exports = {"title":"plans_title_3VVHI","centered-container-subscription":"plans_centered-container-subscription_3Zj3w"};